// Push messaging using Twilio Sync: https://www.twilio.com/docs/sync

import * as Resources from '../util/resources';
import * as User      from '../user';
import ms             from 'ms';
import retry          from '../util/retry';
import store          from '../store';
import SyncClient     from 'twilio-sync';


let syncClient;
let syncStream;


export async function start({ onNotification, onDataMessage }) {
  const sync = await requestSyncFromAPI();

  if (!sync)
    return;

  const { streamID, token } = sync;
  syncClient                = new SyncClient(token);
  syncStream                = await syncClient.stream(streamID);

  syncStream.on('messagePublished', ({ message: { value: { notification, data } } }) => {
    if (notification)
      onNotification(notification);

    if (data)
      onDataMessage(data);
  });

  syncClient.on('tokenAboutToExpire', async() => {
    const newSync = await requestSyncFromAPI();
    // No sync means user signed out or token expired.
    // start() will be called again when there's a new
    // access token available.
    if (newSync) {
      const { token: newToken } = newSync;
      syncClient.updateToken(newToken);
    }
  });
}


export async function stop() {
  if (syncStream)
    syncStream.removeAllListeners();

  if (syncClient)
    await syncClient.shutdown();

  /* eslint-disable require-atomic-updates */
  syncClient = null;
  syncStream = null;
  /* eslint-enable require-atomic-updates */
}


async function requestSyncFromAPI() {
  return await retry(async() => {
    if (!User.isSignedIn(store.getState()))
      return null;

    try {
      const { body } = await store.dispatch(Resources.silentRequest({
        url:     `${API_URL}/me/twilio_sync`,
        timeout: ms('10s')
      }));

      return {
        streamID: body.streamID,
        token:    body.token
      };
    } catch (error) {
      const { statusCode } = error;
      if (statusCode === 0) { // Timeout
        return requestSyncFromAPI();
      } else if (statusCode === 422) { // Sync not available, e.g. Salesforce user.
        return null;
      } else
        throw new Error(`Twilio Sync endpoint returned ${statusCode}`);
    }
  });
}
